import { render, staticRenderFns } from "./SelectedDisabled.vue?vue&type=template&id=68590f6b"
import script from "./SelectedDisabled.vue?vue&type=script&lang=js"
export * from "./SelectedDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports